/* VÆLD — page transition.
   On load: fades the dark overlay out (page reveals from black).
   On internal link click: fades the overlay in, then navigates. */

(function () {
  'use strict';

  var overlay = document.querySelector('.page-transition');
  if (!overlay) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    overlay.classList.add('is-revealed');
    return;
  }

  // Reveal on first paint
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      overlay.classList.add('is-revealed');
    });
  });

  // Re-reveal when navigating back via bfcache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) {
      overlay.classList.remove('is-leaving');
      overlay.classList.add('is-revealed');
    }
  });

  function isInternalLink(a) {
    if (!a || !a.href) return false;
    if (a.target === '_blank') return false;
    if (a.hasAttribute('download')) return false;
    if (a.hasAttribute('data-no-transition')) return false;
    var sameOrigin = a.origin === window.location.origin;
    if (!sameOrigin) return false;
    // Skip hash links within the same page
    if (a.pathname === window.location.pathname && a.search === window.location.search && a.hash) return false;
    // Skip mailto / tel
    if (a.protocol === 'mailto:' || a.protocol === 'tel:') return false;
    return true;
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

    var a = e.target.closest && e.target.closest('a[href]');
    if (!isInternalLink(a)) return;

    e.preventDefault();
    overlay.classList.remove('is-revealed');
    overlay.classList.add('is-leaving');

    setTimeout(function () {
      window.location.href = a.href;
    }, 480);
  });
})();
